import { render, staticRenderFns } from "./ProductsAll.vue?vue&type=template&id=d77090e2&scoped=true"
import script from "./ProductsAll.vue?vue&type=script&lang=js"
export * from "./ProductsAll.vue?vue&type=script&lang=js"
import style0 from "./ProductsAll.vue?vue&type=style&index=0&id=d77090e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77090e2",
  null
  
)

export default component.exports
import {QCard,QCardSection,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QImg})
